import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import SplashFooter from "../common/footer/SplashFooter";
import NewsHero from "../component/news/NewsHero";
import NewsFeatured from "../component/news/NewsFeatured";
import NewsGrid from "../component/news/NewsGrid";
import NewsVideoCarousel from "../component/news/NewsVideoCarousel";
import NewsVideoOverlay from "../component/news/NewsVideoOverlay";
import NewsSidebar from "../component/news/NewsSidebar";
import { logPageView } from "../services/analytics";
import { useBlog } from "../hooks/useBlog";
import './NewsHome.scss';
import ColorSwitcher from "../elements/switcher/ColorSwitcher";

const NewsHome = () => {
  const { posts, videos, banners } = useSelector((state) => state.blog);
  const { getPosts } = useBlog();
  const [showVideoOverlay, setShowVideoOverlay] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    logPageView(window.location.pathname, 'Noticias - Inicio');
    
    if (!posts || posts.length === 0) {
      setLoading(true);
      getPosts(1, 20).finally(() => setLoading(false));
    }
  }, []);

  const handleVideoClick = (index) => {
    setCurrentVideoIndex(index);
    setShowVideoOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowVideoOverlay(false);
  };

  const handleNextVideo = () => {
    if (videos && currentVideoIndex < videos.length - 1) {
      setCurrentVideoIndex(currentVideoIndex + 1);
    }
  };

  const handlePrevVideo = () => {
    if (currentVideoIndex > 0) {
      setCurrentVideoIndex(currentVideoIndex - 1);
    }
  };

  return (
    <>
      <SEO title="Noticias" />
      <main className="news-wrapper">
        <HeaderOne />
          <ColorSwitcher />

        {/* Hero Section con Banners */}
        {banners && banners.length > 0 && (
          <NewsHero banners={banners} />
        )}

        {/* Video Section con indicador y carousel */}
        {videos && videos.length > 0 && (
          <div className="news-video-section">
            <div className="container-fluid">
              <div className="video-section-header">
                <h2 className="video-section-title">
                  <span className="video-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M8 5v14l11-7z" fill="currentColor"/>
                    </svg>
                  </span>
                  Videos Destacados
                  <span className="video-badge">{videos.length}</span>
                </h2>
              </div>
              <NewsVideoCarousel 
                videos={videos}
                onVideoClick={handleVideoClick}
              />
            </div>
          </div>
        )}

        {/* Featured News */}
        {posts && posts.length > 0 && (
          <NewsFeatured posts={posts.slice(0, 4)} />
        )}

        {/* Main Content Grid */}
        <div className="news-main-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-8 col-xl-9">
                <NewsGrid posts={posts} loading={loading} />
              </div>
              <div className="col-lg-4 col-xl-3">
                <NewsSidebar />
              </div>
            </div>
          </div>
        </div>

        <SplashFooter />

        {/* Video Overlay */}
        {showVideoOverlay && videos && videos.length > 0 && (
          <NewsVideoOverlay
            video={videos[currentVideoIndex]}
            videoIndex={currentVideoIndex}
            totalVideos={videos.length}
            onClose={handleCloseOverlay}
            onNext={handleNextVideo}
            onPrev={handlePrevVideo}
          />
        )}
      </main>
    </>
  );
};

export default NewsHome;
